import type { BidListItemProps } from "../bid-list-item";
import { BidListItem } from "../bid-list-item";

/** This wrapper exists just to silent eslint rule  */
export const bidItemContent = ({ ...props }: BidListItemProps) => {
  return <BidListItem {...props} />;
};
